import { DatasourceCanBaseIcon } from '@tableau/icons/DatasourceCanBaseIcon';
import React from 'react';
import _ from 'underscore';

import { Messages } from '../../codegen/Localize';
import { IDataSourceInfo } from '../../datasource/models/IDataSourceInfo';
import { classes } from '../../style';
import { PublishFlowSuccessDialogStyles} from '../styles/PublishFlowSuccessDialogStyles';
import { PublishedFlowAnalyticsExtensionSection } from './PublishedFlowAnalyticsExtensionSection';

export interface PublishFlowSuccessDialogProps {
  flowName: string;
  flowLuid: string;
  showAnalyticsExtensions?: boolean;
  onApplied?: () => void;
  datasourceInfos?: IDataSourceInfo[];
}

export function PublishFlowSuccessDialog(props: PublishFlowSuccessDialogProps) {
  return (
    <div className={PublishFlowSuccessDialogStyles.modal}>
      <div className={classes(PublishFlowSuccessDialogStyles.items)}>
        <span className={PublishFlowSuccessDialogStyles.title}>{Messages.flow()}</span>
        <div className={PublishFlowSuccessDialogStyles.item}>
          <div className={classes(PublishFlowSuccessDialogStyles.icon, PublishFlowSuccessDialogStyles.flowIconResource)}/>
          <div className={PublishFlowSuccessDialogStyles.name}>{props.flowName}</div>
        </div>
        {(props.datasourceInfos && props.datasourceInfos.length > 0) ? renderDatasources(props.datasourceInfos) : null}
      </div>
      {props.showAnalyticsExtensions && <PublishedFlowAnalyticsExtensionSection flowLuid={props.flowLuid} onApplied={props.onApplied} />}
    </div>
  );
}

function renderDatasources(datasourceInfos: IDataSourceInfo[]) {
  const datasourceElements: JSX.Element[] = _.map(datasourceInfos, (datasourceInfo, index) => {
    return (
      <div className={PublishFlowSuccessDialogStyles.item} key={index}>
        <div className={classes(PublishFlowSuccessDialogStyles.icon)}><DatasourceCanBaseIcon size={16} /></div>
        <div className={PublishFlowSuccessDialogStyles.name}>{datasourceInfo.name}</div>
      </div>
    );
  });

  return (
    <div className={PublishFlowSuccessDialogStyles.datasources}>
      <span className={PublishFlowSuccessDialogStyles.title}>{Messages.pageHeaderDatasources()}</span>
      {datasourceElements}
    </div>
  );
}
